import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import SelectableBasepathsPattern from '@mlb/react-patterns/components/SelectableBasepaths/selectableBasepaths';

const SelectableBasepaths = styled(SelectableBasepathsPattern)`
    margin-top: 20px;
`;

const Baserunners = (props) => {

    const {
        fields,
        onChange,
        componentConfig,
    } = props;

    const {
        selected,
        options = [],
        ...field
    } = fields[0];

    const onChangeHandler = useCallback((data) => {

        const { event, changes } = data;

        const nextSelectedItems = [...selected];

        if (event === 'select') {

            const selectedItem = options.find(o => o.value.toString() === changes.value.toString());
            nextSelectedItems.push(selectedItem);

        } else {

            const selectedIndex = selected.findIndex(e => e.value.toString() === changes.value.toString());
            nextSelectedItems.splice(selectedIndex, 1);

        }

        onChange({
            changes,
            selected: nextSelectedItems,
            event,
        }, field);

    }, [
        selected,
        options,
        field,
        onChange,
    ]);

    return (
        <SelectableBasepaths
            selected={selected}
            altText={componentConfig.altText}
            handlers={{
                onChange: onChangeHandler,
            }}
            width={105}
            showHome={true}
            strokeWidth={0.4}
        />
    );

};

Baserunners.propTypes = {
    onChange: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            selected: PropTypes.array.isRequired,
        }).isRequired
    ).isRequired,
    componentConfig: PropTypes.shape({
        altText: PropTypes.string.isRequired,
    }).isRequired,
};

export default Baserunners;
